import { Text } from "@mantine/core";
import { ItemPreferencesName, ItemType } from "../../types/enums";
import { translatedItemPreferences } from "../../utils/translation.utils";

export const ItemPreferenceDescription = (props: {
  preferences: Record<keyof typeof ItemPreferencesName, string | undefined>;
  shouldTranslate: boolean;
  itemType: ItemType;
}) => {
  const { preferences, shouldTranslate, itemType } = props;

  const PREFERENCES_DEFAULT_VALUES = {
    OCCLUSAL_STAINING: "MEDIUM",
    OCCLUSAL_CONTACT_TIGHTNESS: "MEDIUM",
    PROXIMAL_CONTACT_TIGHTNESS: "MEDIUM",
    INTERPROXIMAL_CONTACT_DESIGN: "NORMAL_CONTACT_POINT",
    NO_OCCLUSAL_CLEARANCE: "ASK_DENTIST",
  } as const;

  const hasAtLeastOnNonDefaultValues = (): boolean => {
    if (
      ((preferences.OCCLUSAL_STAINING &&
        preferences.OCCLUSAL_STAINING !==
          PREFERENCES_DEFAULT_VALUES.OCCLUSAL_STAINING) ||
        (preferences.OCCLUSAL_CONTACT_TIGHTNESS &&
          preferences.OCCLUSAL_CONTACT_TIGHTNESS !==
            PREFERENCES_DEFAULT_VALUES.OCCLUSAL_CONTACT_TIGHTNESS) ||
        (preferences.PROXIMAL_CONTACT_TIGHTNESS &&
          preferences.PROXIMAL_CONTACT_TIGHTNESS !==
            PREFERENCES_DEFAULT_VALUES.PROXIMAL_CONTACT_TIGHTNESS) ||
        (preferences.INTERPROXIMAL_CONTACT_DESIGN &&
          preferences.INTERPROXIMAL_CONTACT_DESIGN !==
            PREFERENCES_DEFAULT_VALUES.INTERPROXIMAL_CONTACT_DESIGN) ||
        (preferences.NO_OCCLUSAL_CLEARANCE &&
          preferences.NO_OCCLUSAL_CLEARANCE !==
            PREFERENCES_DEFAULT_VALUES.NO_OCCLUSAL_CLEARANCE) ||
        preferences.ANTERIOR_POSTERIOR_PONTIC_DESIGN) &&
      itemType !== ItemType.INLAY_CORE
    ) {
      return true;
    }
    return false;
  };

  if (!hasAtLeastOnNonDefaultValues()) {
    return null;
  }

  return (
    <>
      <Text size="sm">
        {shouldTranslate ? "- Preferences" : "- Préférences"}
      </Text>
      <div style={{ marginLeft: "1rem" }}>
        {preferences.OCCLUSAL_STAINING &&
          preferences.OCCLUSAL_STAINING !==
            PREFERENCES_DEFAULT_VALUES.OCCLUSAL_STAINING && (
            <Text size="sm">
              {translatedItemPreferences(
                ItemPreferencesName.OCCLUSAL_STAINING,
                preferences,
                shouldTranslate
              )}
            </Text>
          )}
        {preferences.OCCLUSAL_CONTACT_TIGHTNESS &&
          preferences.OCCLUSAL_CONTACT_TIGHTNESS !==
            PREFERENCES_DEFAULT_VALUES.OCCLUSAL_CONTACT_TIGHTNESS && (
            <Text size="sm">
              {translatedItemPreferences(
                ItemPreferencesName.OCCLUSAL_CONTACT_TIGHTNESS,
                preferences,
                shouldTranslate
              )}
            </Text>
          )}
        {preferences.PROXIMAL_CONTACT_TIGHTNESS &&
          preferences.PROXIMAL_CONTACT_TIGHTNESS !==
            PREFERENCES_DEFAULT_VALUES.PROXIMAL_CONTACT_TIGHTNESS && (
            <Text size="sm">
              {translatedItemPreferences(
                ItemPreferencesName.PROXIMAL_CONTACT_TIGHTNESS,
                preferences,
                shouldTranslate
              )}
            </Text>
          )}
        {preferences.INTERPROXIMAL_CONTACT_DESIGN &&
          preferences.INTERPROXIMAL_CONTACT_DESIGN !==
            PREFERENCES_DEFAULT_VALUES.INTERPROXIMAL_CONTACT_DESIGN && (
            <Text size="sm">
              {translatedItemPreferences(
                ItemPreferencesName.INTERPROXIMAL_CONTACT_DESIGN,
                preferences,
                shouldTranslate
              )}
            </Text>
          )}
        {preferences.ANTERIOR_POSTERIOR_PONTIC_DESIGN && (
          <Text size="sm">
            {translatedItemPreferences(
              ItemPreferencesName.ANTERIOR_POSTERIOR_PONTIC_DESIGN,
              preferences,
              shouldTranslate
            )}
          </Text>
        )}
      </div>
    </>
  );
};
